import React, { FC } from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';

import { ConnectedRouter } from 'connected-react-router';

import { history } from '@/store';
import { Layout } from '../components/layout';
import { generateRoutes, lazy } from './navigation.helpers';
import { RoutesDef } from './navigation.models';
import { rootRoutePaths, rootRoutes } from './routes/root';

const rootRoutesDef: RoutesDef<rootRoutes> = {
  [rootRoutes.AUTHENTICATED]: {
    path: rootRoutePaths[rootRoutes.AUTHENTICATED],
    component: lazy(import(/* webpackChunkName: "authenticated" */ '@/features/authenticated/')),
  },
  [rootRoutes.UNAUTHENTICATED]: {
    path: rootRoutePaths[rootRoutes.UNAUTHENTICATED],
    component: lazy(import(/* webpackChunkName: "unauthenticated" */ '@/features/unauthenticated')),
  },
};

const rootRoutesElement = generateRoutes(rootRoutesDef, 'root', rootRoutePaths[rootRoutes.UNAUTHENTICATED]);

export const RootNavigation: FC = () => (
  <Router>
    <ConnectedRouter history={history}>
      <Layout>
        <Switch>{rootRoutesElement}</Switch>
      </Layout>
    </ConnectedRouter>
  </Router>
);
